import en from './en.json';
import fr from './fr.json';

export const resources = { en, fr };

export const languages = { en: 'en', fr: 'fr' };
